<div class="form-section">
    <div class="section-title">
        {{ 'label.remark-from-handling-officer' | translate }}
    </div>
    <div class="form-grid">
        <div class="form-field">
            <label>{{ 'label.approved-amount' | translate }}</label>
            <input type="text" value="{{this.remark.amount | decimalComma}}" class="form-control" [readonly]="true">
        </div>

        <div class="form-field">
            <label>{{ 'label.currency' | translate }}</label>
            <input type="text" value="{{this.remark.currency}}" class="form-control" [readonly]="true">
        </div>

        <div class="form-field">
            <label>{{ 'label.approved-interest-amount' | translate }}</label>
            <input type="text" value="{{this.remark.interestAmount | decimalComma}}" class="form-control" [readonly]="true">
        </div>

        <div class="form-field">
            <label>{{ 'label.interest-comment' | translate }}</label>
            <input type="text" value="{{this.remark.interestComment}}" class="form-control" [readonly]="true">
        </div>

        <div class="form-field">
            <label>{{ 'label.approved-preferential-right' | translate }}</label>
            <input type="text" value="{{ this.remark.preferentialRight.name }} ({{ this.remark.preferentialRight.description }})" class="form-control" [readonly]="true">
        </div>

        <div class="form-field">
            <label>{{ 'label.approved-by-creditor' | translate }}</label>
            <input type="text" value="{{ this.remark.isApproved ? ('button.ja' | translate) : ('button.nej' | translate) }}" class="form-control" [readonly]="true">
        </div>
    </div>
</div>
<div class="form-section">
    <div class="section-title">
        {{ 'label.remark-chat' | translate }}
    </div>
    <p class="text-muted" *ngIf="!this.remark.messages?.length">{{ 'label.no-messages' | translate }}</p>
    <button type="button" class="d-flex justify-content-center text-muted btn btn-link w-100" (click)="visaAllaMeddelanden = true" *ngIf="(remark.messages?.length > antalMeddelandenSomVisas) && !visaAllaMeddelanden" [attr.aria-label]="'label.show-earlier-messages' | translate">
        <fa-icon [icon]="['fas', 'caret-down']" size="lg"></fa-icon>
    </button>
    <ng-container *ngFor="let meddelande of this.remark.messages | orderBy: 'createdUtc'; let i = index">
        <div class="media pt-3" *ngIf="(i >= this.remark.messages.length - antalMeddelandenSomVisas) || visaAllaMeddelanden">
            <div class="avatar-circle me-3 ms-lg-3 ms-0 z-depth-1" [style.background-color]="meddelande.isFromGk ? '#137A82' : '#2C5A78'" [title]="meddelande.createdUtc | localizeddate:'medium'">
                <span class="initials">{{ meddelande.createdByInitials }}</span>
            </div>
            <p class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
                <span class="d-block"><strong class="text-gray-dark">{{ meddelande.createdBy }}</strong>, {{meddelande.createdUtc | localizeddate:'shortDate' }} {{meddelande.createdUtc | localizeddate:'mediumTime' }}</span>
                <span style="font-size: 1.2rem; white-space: pre-wrap">{{ meddelande.message }}</span>
                <file-link-fromgk *ngFor="let file of meddelande.files" [fileName]="file.fileName" [fileId]="file.id" [creditorCaseId]="this.caseId" [creditorId]="creditorId"></file-link-fromgk>
            </p>
        </div>
    </ng-container>
</div>
<div class="form-section">
    <form [formGroup]="userForm" (ngSubmit)="createMessage()">
        <p class="search-text-label mb-4">
            {{ 'texts.remark-answer-info' | translate }}
        </p>
        <div class="mb-3">
            <label class="form-label">{{ 'label.approve-remark' | translate }}</label>
            <div class="d-flex gap-3">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" formControlName="approved" id="approve-yes" value="true">
                    <label class="form-check-label" for="approve-yes">{{ 'button.ja' | translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" formControlName="approved" id="approve-no" value="false">
                    <label class="form-check-label" for="approve-no">{{ 'button.nej' | translate }}</label>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <textarea class="form-control mt-3" rows="3" placeholder="{{ 'label.type-here' | translate }}" id="message-text" name="message" formControlName="message"></textarea>
        </div>
        <div style="display: flex; justify-content: flex-end; margin-top: -10px;">
            <label *ngIf="messageForm.dirty" class="smaller-label" [ngClass]="messageForm.invalid && message.length ? 'label-danger' : 'label-default'">{{ message.length |
                localizednumber }} / {{ messageMaxLength | localizednumber }} tecken</label>
        </div>
        <file-upload />
        <div class="container-fluid mt-3">
            <div class="row">
                <button type="submit" [disabled]="isSubmitting || userForm.get('approved').value === null || userForm.invalid || (userForm.get('approved').value === 'false' && message.trim().length === 0 && files.length === 0) || (userForm.get('approved').disabled && message.trim().length === 0 && files.length === 0)" class="btn-garanti btn-blue ms-auto"><fa-icon [icon]="['fas', 'envelope']" class="me-2"></fa-icon>{{'label.send-message' | translate }}</button>
            </div>
        </div>
    </form>
</div>